import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export default function PubChangePassword() {
    const phoneNo = useSelector(state => state.pubLogin.userPhone);
    const [passwords, setPasswords] = useState({
        currentPassword: "",
        newPassword: ""
    });

    const handleChange = (e) => {
        setPasswords({
            ...passwords,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/changePassword`, {
                phone: phoneNo,
                currentPassword: passwords.currentPassword,
                newPassword: passwords.newPassword
            });
            toast.success(response.data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (error) {
            console.error("Error changing password:", error);
            toast.error("You have entered an invalid password", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    return (
        <div className="container d-flex flex-column align-items-center mt-5">
            <h1 className="text-center mb-4">Change Password</h1>
            <div className="card shadow-lg p-4" style={cardStyle}>
                <div style={contentStyle}>
                    <form className="form-group w-100" onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="currentPassword" style={labelStyle}>Current Password</label>
                            <input
                                type="password"
                                name="currentPassword"
                                id="currentPassword"
                                className="form-control"
                                style={inputStyle}
                                placeholder="Enter current password"
                                value={passwords.currentPassword}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label htmlFor="newPassword" style={labelStyle}>New Password</label>
                            <input
                                type="password"
                                name="newPassword"
                                id="newPassword"
                                className="form-control"
                                style={inputStyle}
                                placeholder="Enter new password"
                                value={passwords.newPassword}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="justify-content-center d-flex">
                            <button type="submit" className="btn btn-primary btn-lg rounded-pill px-5 py-3 mt-4 mb-4 shadow">
                                Change Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

const cardStyle = {
    background: "rgba(255, 255, 255, 0)", // Fully transparent background
    backdropFilter: "blur(20px)", // Full blur effect
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    padding: 0 // Remove padding from card to ensure content container covers it
};

const contentStyle = {
    
    borderRadius: "10px",
    padding: "1rem" // Add padding for content
};

const labelStyle = {
    fontWeight: "bold", // Make labels bold
    color: "#000", // Ensure labels are clearly visible
};

const inputStyle = {
    fontWeight: "bold", // Make input text bold
}; 